

export default {
  name: "items_grid",
  data() {
    return {
      display: "grid",
      filterOpen: false,
      filters: this.$store.getters.sub.filters,
      pagination: this.$store.getters.pagination,
      items: this.$store.getters.items,
    };
  },
  watch: {
    filterOpen: function (v) {
      if (v) {
        document.querySelector("body").classList.add("overflow-hidden");
      } else {
        document.querySelector("body").classList.remove("overflow-hidden");
      }
    },
  },
  created() {},
  mounted() {
    this.$nuxt.$on('filterToggle',(v)=>{
      this.filterOpen = !this.filterOpen;
    })
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    clearQ() {
      this.search = this.search
        .split("&")
        .filter((s) => !s.includes("q="))
        .join("&");
      this.doSearch();
    },
    resetFilters() {
      this.$router.push("/search/+limit=16");
      return;
      this.sideFilters = {
        business_activity: "",
        family: "",
        subfamily: "",
        category: "",
        subcategory: "",
        sort: "asc",
      };
      this.page = 1;
      this.doSearch("&limit=16");
    },

    treeSearch(u) {
      this.pagination = [];
      this.$axios
        .$get("items/tree/?&items=1&" + u)
        .then((res) => {
          this.items = res.docs;
          this.page = res.page;
          this.pages = res.pages;
          for (let i = 1; i <= res.pages; i++) {
            if (i == 1) {
              this.pagination.push(i);
            }
            if (
              i > res.page - 5 &&
              i < res.page + 5 &&
              i > 1 &&
              i < res.pages
            ) {
              this.pagination.push(i);
            }
            if (i == res.pages) {
              this.pagination.push(i);
            }
          }
          this.limit = res.limit;
          this.total = res.total;
        })
        .catch((e) => {
          this.$clerk.hyperAlert({
            time: 3000,
            title: "Κάτι πήγε στραβά!",
            icon: "info",
            cancelShow: false,
          });
        });
    },
  },
};
